import { ContextStore } from 'bernie-plugin-mobx';
import { CampaignByIdResponse } from '../../hooks/useCampaignById';
import { PropertySearchResponse } from '../../hooks/useLodgingPwaPropertySearch';
import {
  CampaignByIdQuery,
  CampaignRecommendationsWithOffersQuery,
  PropertySort,
  DateInput,
} from 'src/common/__generated__/api/types';
import Campaigns = CampaignByIdQuery.Campaigns;
import Offers = CampaignRecommendationsWithOffersQuery.Offers;

type FetchOptions<CampaignByIdQueryQueryVariables, CampaignByIdResponse> = {
  variables: CampaignByIdQueryQueryVariables;
  updateQuery: (
    previousQueryResult: CampaignByIdResponse,
    options: {
      fetchMoreResult?: CampaignByIdResponse;
      variables?: CampaignByIdQueryQueryVariables;
    }
  ) => CampaignByIdResponse;
};

type FechMore<V, D> = (options: FetchOptions<V, D>) => void;

export const buildFetchMoreDeals =
  <Variables, Data>(fetchMore: FechMore<Variables, Data>, currentVariables: Variables): FechMore<Variables, Data> =>
  ({ updateQuery, variables: newVariables }): void => {
    fetchMore({
      updateQuery,
      variables: {
        ...currentVariables,
        ...newVariables,
      },
    });
  };

export const isGridSlickView = (visibleControl) => {
  return visibleControl === undefined || visibleControl === 'grid-slick';
};

interface FetchMoreObject {
  variables: any;
}

export interface DealsProps {
  campaignId: string;
  pageNumber: number;
  pageSize: number;
  userLat?: string;
  userLong?: string;
  errorMessage?: string;
  viewMoreCtaText?: string;
  destinationId?: string;
  title: string;
  subheadline: string;
  summary: string;
  cTACopy: string;
  cTAUrl: string;
  propertyCount: number;
  hotelCardCtaCopy: string;
  mcicidTemplateType: string;
  mcicidCampaignUrl: string;
  mcicidReferrerId: string;
  mcicidMainUrl: string;
  showCampaignTitles?: boolean;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
  enableTripAttach?: boolean;
  displayPropertyCount?: boolean;
  enableLivePricing?: boolean;
}

export interface DealsComponentProps {
  data?: CampaignByIdResponse;
  errorMessage?: string;
  fetchMore: (o: FetchMoreObject) => void;
  context?: ContextStore;
  viewMoreCtaText?: string;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
}

export interface PropertySearchProps {
  regionName: string;
  regionId: string;
  priceMin: number;
  priceMax: number;
  sort: PropertySort;
  checkInDate: DateInput;
  checkOutDate: DateInput;
  adults: number;
  title: string;
  subheadline: string;
  summary: string;
  cTACopy: string;
  cTAUrl: string;
  propertyCount: number;
  hotelCardCtaCopy: string;
  mcicidTemplateType: string;
  mcicidCampaignUrl: string;
  mcicidReferrerId: string;
  mcicidMainUrl?: string;
  starRating?: string;
  guestRating?: string;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
  travelerType?: any;
  memberOnlyDeals?: any;
  paymentType?: any;
}

export interface PropertySearchComponentProps {
  data?: PropertySearchResponse;
  errorMessage?: string;
  fetchMore?: (o: FetchMoreObject) => void;
  context?: ContextStore;
  viewMoreCtaText?: string;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
}

export interface DealsViewsProps {
  campaign: Campaigns | any;
  context?: ContextStore;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
}

export interface PropertySearchViewsProps {
  properties: any;
  allProperties: any;
  propertySearchParam?: any;
  context?: ContextStore;
  visibleControl?: 'grid-slick' | 'media-studio-slick';
}

export interface PriceComponentProps {
  offer: Offers;
  cardIndex: number;
  campaignId: string;
  moduleName: string;
  cardClicked: () => void;
}

/** Image Badges */
export interface HotelInventoryCardProps {
  offer: Offers;
  cardIndex: number;
  campaignId: string;
  moduleName: string;
  border?: boolean;
}

export interface MarkIconProps {
  context: ContextStore;
}

export interface DealsCarouselViewsProps {
  campaign: Campaigns | any;
  renderDealsCampaignCard: (b: Offers, c: number) => JSX.Element;
  focusElement: React.MutableRefObject<any>;
}

export interface DealsPropertyPwaCarouselViewsProps {
  campaign: any;
  renderDealsCampaignCard: (a: any, b: any, c: number) => JSX.Element;
  focusElement: React.MutableRefObject<any>;
}

export interface SeparatorProps {
  modAvailabilityText?: string;
  modTagText?: string;
  discountBadge?: string;
}

export interface HotelByIdsProps {
  checkInDate: string;
  checkOutDate: string;
  hotelIds: string;
  propertyCount: number;
  cTACopy: string;
  mccidData?: {
    templateType?: string;
    campaignUrl?: string;
    referrerId?: string;
    mainUrl?: string;
  }; 
}